<template>
  <v-card v-if="loading" class="control-card preload-box h-100 pa-2 " style="min-height: 380px;">
    <v-progress-circular indeterminate color="primary" class="h-100"></v-progress-circular>
  </v-card>
  <v-card v-else class="control-card" style="gap: 16px;">
    <p class="control-card__title">Дисплеи Визинформ</p>
    <v-layout d-flex align-start wrap style="gap: 16px;">
      <v-layout v-for="(displayGroup, groupIndex) in displayGroups" :key="groupIndex" d-flex column
        style="gap: 16px; flex: 1;">
        <div v-for="(display, index) in displayGroup" :key="index" class="control-services__card">
          <p>{{ display.name }}</p>
          <div v-for="(card, cardIndex) in display.value" :key="cardIndex" class="control-card--small mt-2">
            <img v-if="card.value === 'on'" src="/static/img/control/tablo_on.svg" />
            <img v-else-if="card.value === 'waiting'" src="/static/img/control/tablo_idle.svg" />
            <img v-else-if="card.value === 'off'" src="/static/img/control/tablo_off.svg" />
            <p>{{ card.name || '-' }}</p>
          </div>
        </div>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import store from '@/store'
export default {
  props: ['loading'],
  data: () => ({
  }),
  computed: {
    controlsData() {
      return store.getters['controls/getControls']
    },
    displays() {
      return this.controlsData.displays || []
    },
    displayGroups() {
      const chunkSize = 2;
      const groups = [];
      for (let i = 0; i < this.displays.length; i += chunkSize) {
        groups.push(this.displays.slice(i, i + chunkSize));
      }
      return groups;
    },
  }
}
</script>
